import React, { PureComponent, Fragment } from 'react';

import { withStyles, Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography, IconButton, Select, MenuItem} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
  tablecell: {
    padding: 4,
    '&>*':{
      display: 'inline-flex'
    }
  },
});

class MentorTable extends PureComponent {
  state = {
    selectedUmp: {},
    error: ''
  };

  mentees = [
    {}
  ]

  componentDidMount() {
    const {
      fetchingMentorsList,
      getMentorsList,
      fetchingUmpiresList,
      getUmpiresList,
      fetchingStatus,
      getUmpInfo,
      userSeason
    } = this.props;
    if (fetchingMentorsList !== 'Loading' || fetchingMentorsList !== 'Loaded') {
      getMentorsList(userSeason);
    }
    if (fetchingUmpiresList !== 'Loading' || fetchingUmpiresList !== 'Loaded') {
      getUmpiresList(userSeason);
    }
    if (fetchingStatus !== 'Loading' || fetchingStatus !== 'Loaded' ) {
      getUmpInfo();
    }
  }

  componentDidUpdate(prevProps) {
    const { userSeason, getMentorsList, getUmpiresList } = this.props;
    if (userSeason !== prevProps.userSeason) {
      getMentorsList(userSeason);
      getUmpiresList(userSeason);
    }
  }

  handleSelectUmp = (event, mentorId, column) => {
    const { umpiresList } = this.props;
    const { selectedUmp } = this.state;
    const index = event.target.value;
    const mentee = umpiresList[index-1];

    if (index > 0 ) {
      this.setState({
        selectedUmp: { ...selectedUmp,
          [mentorId]: {
            mentees: {
              [column] : {
                menteeId: mentee.value,
                value: index
              }
            }
          }
        }
      });
    }
    else {
      this.setState({ selectedUmp: { [mentorId]: {mentees: {[column] : {
        menteeId: null,
        value: 0
       } }}}});
    };
  };

  handleAssignMentee = (mentorId, column) => {
    const { selectedUmp } = this.state;
    if (selectedUmp[mentorId] !== null) {
      const menteeId = selectedUmp[mentorId].mentees[column].menteeId;
      this.props.updateMentorsMentees(mentorId, menteeId, column, this.props.userSeason, 'add');
    } else {
      this.setState({ error: 'Please select an umpire.' });
    }
  };

  handleRemoveMentee = (mentorId, menteeId, column) => {
    this.props.updateMentorsMentees(mentorId, menteeId, column, this.props.userSeason, 'remove');
  };

  render() {
    const { fetchingMentorsList, fetchingUmpiresList} = this.props;
    const { classes } = this.props;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div  className={classes.title}>
            <Typography variant="h5">Mentor Table</Typography>
          </div>
          <div className={classes.spacer} />
        </Toolbar>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell padding="dense"><Typography variant="body2">Mentor</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">Mentee 1</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">Mentee 2</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">Mentee 3</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">Mentee 4</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">Mentee 5</Typography></TableCell>
            </TableRow>
          </TableHead>
          {fetchingMentorsList === 'Loaded' && fetchingUmpiresList === 'Loaded' && this.renderTableBody()}
        </Table>
      </Paper>
    );
  }

  renderTableBody() {
    const { mentorsList, umpiresList, umpiresSeason, classes} = this.props;
    const { selectedUmp } = this.state;

    return (
      <TableBody>
      {mentorsList.map(mentor => {
        return (
          <TableRow className={classes.tablerow} key={mentor.memberId}>
            <TableCell padding="dense"><Typography variant="body2">{umpiresSeason[mentor.memberId].name}</Typography></TableCell>
            {[1,2,3,4,5].map(i => {
              //Look for a selected Mentee for this Mentor to initialize the select control
              const isMentor = selectedUmp[mentor.memberId] ? true : false;
              let isMentee = false;
              let value = 0;
              if (isMentor) {
                isMentee = selectedUmp[mentor.memberId].mentees[`mentee${i}`] ? true : false;
                if (isMentee) value = selectedUmp[mentor.memberId].mentees[`mentee${i}`].value;
              }
              return (
                <TableCell key={i} className={classes.tablecell} padding="dense">
                  {mentor[`mentee${i}Id`] === null ? (
                    <Fragment>
                      <Select
                        name="umpireSearch"
                        value={value}
                        onChange={selectedOption =>
                          this.handleSelectUmp(selectedOption, mentor.memberId, `mentee${i}`)}
                      >
                        <MenuItem disabled value={0}>
                          <Typography variant="body2"><em>Select Umpire</em></Typography>
                        </MenuItem>
                        {umpiresList.map((ump, index) => (
                          <MenuItem key={ump.value} value={index+1}>
                            <Typography variant="body2">{ump.label} ({ump.level})</Typography>
                          </MenuItem>
                        ))}
                      </Select>
                      <IconButton
                        size="small" color="primary" disabled={(!isMentee)}
                        onClick={() => this.handleAssignMentee(mentor.memberId, `mentee${i}`)}
                      >
                        <AddIcon />
                      </IconButton>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Typography variant="body2">{umpiresSeason[mentor[`mentee${i}Id`]].name}</Typography>
                      <IconButton
                        size="small" color="secondary"
                        onClick={() => this.handleRemoveMentee(mentor.memberId, mentor[`mentee${i}Id`], `mentee${i}`)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Fragment>
                  )}
                </TableCell>
              )
            })}
          </TableRow>
        );
      })}
    </TableBody>
    );
  }
}

MentorTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(MentorTable);



// WEBPACK FOOTER //
// ./src/components/MentorTable.js